import { render, staticRenderFns } from "./CreateAnnouncement.vue?vue&type=template&id=3aeab75a"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=ts"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=ts"
import style0 from "./CreateAnnouncement.vue?vue&type=style&index=0&id=3aeab75a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports